<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                        <div>
                            <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                        </div>

                        <v-tabs class="mt-3" v-model="current_tab" color="primary-dark" centered>
                            <v-tab value="tab-charge">
                                <v-icon>mdi-currency-eur</v-icon>
                                À encaisser
                            </v-tab>
                            <v-tab value="tab-failed">
                                <v-icon class="mr-2">mdi-alert</v-icon>
                                Échecs d'encaissement
                            </v-tab>
                        </v-tabs>

                        <v-window v-model="current_tab">
                            <v-window-item value="tab-charge">
                                <div class="d-flex flex-column ga-2 pt-3">
                                    <div>Cette interface vous permet d'encaisser les commandes en attente. Il y a
                                        actuellement <b>{{
                                            pendings_commandes.length }}</b> commandes à encaisser.</div>
                                    <div class="d-flex justify-space-between align-center ga-2">
                                        <SportipsButton icon="mdi-currency-eur" chevron
                                            @click="launch_charge_commandes()">Lancer
                                            l'encaissement automatique</SportipsButton>
                                        <v-text-field v-model="limit" type="number" min="1" max="1000"
                                            label="Nombre de commandes à encaisser" density="compact"
                                            hide-details></v-text-field>
                                        <div>
                                            <div>Succès: {{ stats.success }}</div>
                                            <div>Erreur: {{ stats.error }}</div>
                                            <div>Total: {{ stats.total }}</div>
                                        </div>
                                    </div>

                                    <div v-for="commande in pendings_commandes" :key="commande.id"
                                        class="spo-card pa-2 rounded bordered">
                                        <div class="d-flex justify-space-between">
                                            <div>
                                                <div class="font-weight-bold">Commande n°{{ commande.uuid }}</div>
                                                <div class="text-subtitle-1">{{ commande.prix_total }}€ | Validée le {{
                                                    $moment(commande.created_at).format("DD/MM/YYYY à HH:mm") }}</div>
                                            </div>
                                            <div>
                                                <v-chip :color="get_color_status(commande.status)" variant="elevated"
                                                    elevation="0">
                                                    {{ commande.status }}
                                                </v-chip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-window-item>

                            <v-window-item value="tab-failed">

                                <div class="d-flex flex-column ga-2 pt-3">
                                    <div>Commandes dont l'encaissement a échoué. <b>{{ unpaid_commandes.length }}</b>
                                        commande(s), dont <b>{{ unpaid_without_email.length }}</b> sans mail de paiement
                                        renvoyé.</div>
                                    <div class="d-flex justify-space-between align-center ga-2">
                                        <SportipsButton icon="mdi-email-fast" chevron
                                            :disabled="sending_all || unpaid_without_email.length == 0"
                                            @click="send_all_failed_emails()">Renvoyer le mail à tous les non envoyés
                                        </SportipsButton>
                                        <div>
                                            <div>Succès: {{ email_stats.success }}</div>
                                            <div>Erreur: {{ email_stats.error }}</div>
                                            <div>Total: {{ email_stats.total }}</div>
                                        </div>
                                    </div>

                                    <v-table density="compact">
                                        <thead>
                                            <tr>
                                                <th class="text-left">Commande</th>
                                                <th class="text-left">Montant</th>
                                                <th class="text-left">Date</th>
                                                <th class="text-left">Statut</th>
                                                <th class="text-left">Statut commande</th>
                                                <th class="text-left">Mail renvoyé</th>
                                                <th class="text-left">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="commande in unpaid_commandes" :key="commande.id">
                                                <td>{{ commande.uuid }}</td>
                                                <td>{{ commande.prix_total }}€</td>
                                                <td>{{ $moment(commande.created_at).format("DD/MM/YYYY à HH:mm") }}</td>
                                                <td>
                                                    <v-chip :color="get_color_status(commande.status)"
                                                        variant="elevated" elevation="0" size="small">
                                                        {{ commande.status }}
                                                    </v-chip>
                                                </td>
                                                <td>{{ commande.statut }}</td>
                                                <td>
                                                    <v-chip v-if="is_email_sent(commande)" color="green-darken-4"
                                                        variant="elevated" elevation="0" size="small">Oui</v-chip>
                                                    <v-chip v-else color="primary-dark" variant="elevated" elevation="0"
                                                        size="small">Non</v-chip>
                                                </td>
                                                <td>
                                                    <SportipsButton size="small" icon="mdi-email-sync" chevron
                                                        :disabled="sending_all || sending_id == commande.id"
                                                        @click="send_failed_email(commande)">
                                                        Renvoyer le mail
                                                    </SportipsButton>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </div>
                            </v-window-item>
                        </v-window>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AdminService from "@/services/admin.service";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    name: 'ChargePendingsCommandes',
    data() {
        return {
            current_tab: "tab-charge",
            pendings_commandes: [],
            unpaid_commandes: [],
            limit: 100,
            sending_all: false,
            sending_id: null,
            stats: {
                success: 0,
                error: 0,
                total: 0,
            },
            email_stats: {
                success: 0,
                error: 0,
                total: 0,
            }
        }
    },
    computed: {
        ...mapStores(useMainStore),
        unpaid_without_email() {
            return this.unpaid_commandes.filter((commande) => !this.is_email_sent(commande));
        }
    },
    methods: {
        get_color_status(status) {
            if (status == 'PAID') return 'green-darken-4';
            if (status == 'PENDING') return 'primary-dark';
            return 'red-darken-4';
        },
        is_email_sent(commande) {
            return commande.retry_email_send == 1;
        },
        async fetch_pendings_commandes() {
            let request = await AdminService.getPendingsCommandes(this.mainStore.module.id);
            if (request) {
                this.pendings_commandes = request;
                // exclure de la liste les commandes dont le timestamp est aujourd'hui
                this.pendings_commandes = this.pendings_commandes.filter((commande) => {
                    return !this.$moment(commande.timestamp).isSame(this.$moment(), 'day');
                });
            }
        },
        async fetch_unpaid_commandes() {
            let request = await AdminService.getUnpaidPendingsCommandes(this.mainStore.module.id);
            if (request) {
                this.unpaid_commandes = request;
            }
        },
        async launch_charge_commandes() {
            this.stats.success = 0;
            this.stats.error = 0;
            this.stats.total = 0;
            for (let i = 0; i < this.limit; i++) {
                if (this.pendings_commandes[i].status == 'PAID') continue;
                let response = await AdminService.chargeCommande(this.pendings_commandes[i].id_commande);
                if (response) {
                    this.pendings_commandes[i].status = response;
                    if (response == "PAID") {
                        this.stats.success++;
                    }
                    else {
                        this.stats.error++;
                    }
                    this.stats.total++;
                }
            }

        },
        async send_failed_email(commande) {
            this.sending_id = commande.id;
            let response = await AdminService.sendFailedChargeEmail(commande.id);
            this.sending_id = null;
            if (response == "EMAIL_SENT") {
                commande.retry_email_send = 1;
                return true;
            }
            return false;
        },
        async send_all_failed_emails() {
            this.sending_all = true;
            this.email_stats.success = 0;
            this.email_stats.error = 0;
            this.email_stats.total = 0;
            const targets = [...this.unpaid_without_email];
            for (const commande of targets) {
                let sent = await this.send_failed_email(commande);
                if (sent) {
                    this.email_stats.success++;
                }
                else {
                    this.email_stats.error++;
                }
                this.email_stats.total++;

            }
            this.sending_all = false;
        }
    },
    async mounted() {

        if (!this.mainStore.authAdmin.hasSuperAdminRights) {
            this.$router.push({ name: 'Administration' });
        }
        await this.fetch_pendings_commandes();
        await this.fetch_unpaid_commandes();

    }
}
</script>

<style lang="scss" scoped></style>
